<div
  class="image-preview-container"
  (mousemove)="minimapDown($event)"
  (mousedown)="minimapDown($event)"
  #previewContainer
  [style.width]="(previewAspect > 100 ? 160 * assetAspect : 160) + 'px'"
  [@preview]="showPreview ? 'shown' : 'hidden'"
>
  <div class="image-preview" [style.paddingBottom]="previewAspect + '%'" #el>
    @if (showPreview) {
      <img
        [src]="
          version
            | assetVersionUrl
              : asset
              : version['status']
              : el.clientWidth
              : el.clientHeight
              : asset.watermark_enabled
              : undefined
              : activePage
        "
        alt=""
      />
    }
    <div
      class="image-preview-position"
      [style.width]="crop.width + '%'"
      [style.height]="crop.height + '%'"
      [style.transform]="'translateZ(2px)'"
      [style.left]="crop.x + '%'"
      [style.top]="crop.y + '%'"
      [class.no-animation]="noAnimation"
      loading="lazy"
    ></div>
  </div>
</div>
